import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { FullScreenLoader } from "@/components/feedback/FullScreenLoader";

interface LocationState {
  from?: { pathname: string };
}

/** Used on /login so a signed-in user is sent straight to the app. */
export function RedirectIfAuthenticated({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <FullScreenLoader />;
  }

  if (isAuthenticated) {
    const state = location.state as LocationState | null;
    const destination = state?.from?.pathname ?? "/dashboard";
    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
}
